import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import Home from "@/pages/Home";
import Article from "@/pages/Article";
import ArticlesIndex from "@/pages/ArticlesIndex";
import Service from "@/pages/Service";
import PsixologosPatra from "@/pages/PsixologosPatra";
import PsixotherapeiaPatra from "@/pages/PsixotherapeiaPatra";
import LocalArea from "@/pages/LocalArea";
import ThankYou from "@/pages/ThankYou";
import KrisiPanikou from "@/pages/KrisiPanikou";
import Privacy from "@/pages/Privacy";
import Rantevou from "@/pages/Rantevou";
import Diaxeirisi from "@/pages/Diaxeirisi";
import MobileCTA from "@/components/sections/MobileCTA";
import CookieBanner from "@/components/sections/CookieBanner";
import ChatWidget from "@/components/sections/ChatWidget";
import { Toaster } from "@/components/ui/sonner";

function ScrollToHash() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }
    const id = hash.slice(1);
    let attempts = 0;
    let timer;
    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else if (attempts++ < 20) {
        timer = setTimeout(tryScroll, 100);
      }
    };
    tryScroll();
    return () => clearTimeout(timer);
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToHash />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/psixologos-patra" element={<PsixologosPatra />} />
            <Route path="/psixotherapeia-patra" element={<PsixotherapeiaPatra />} />
            <Route path="/psixologos-rio" element={<LocalArea />} />
            <Route path="/psixologos-aigio" element={<LocalArea />} />
            <Route path="/psixologos-foitites-patras" element={<LocalArea />} />
            <Route path="/efxaristo" element={<ThankYou />} />
            <Route path="/krisi-panikou" element={<KrisiPanikou />} />
            <Route path="/politiki-aporritou" element={<Privacy />} />
            <Route path="/rantevou" element={<Rantevou />} />
            <Route path="/diaxeirisi" element={<Diaxeirisi />} />
            <Route path="/arthra" element={<ArticlesIndex />} />
            <Route path="/arthra/:slug" element={<Article />} />
            <Route path="/ipiresies/:slug" element={<Service />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <MobileCTA />
          <CookieBanner />
          <ChatWidget />
        </BrowserRouter>
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "hsl(var(--card))",
              color: "hsl(var(--foreground))",
              border: "1px solid hsl(var(--border))",
              fontFamily: "'Manrope', sans-serif",
            },
          }}
        />
      </div>
    </HelmetProvider>
  );
}

export default App;
